import { render } from "./NkSettingsRemote.vue?vue&type=template&id=38dc1089"
const script = {}

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__